/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import styles from './HeadlineUnderline.module.scss';

export function HeadlineUnderline() {
  return <div data-testid="underline" className={styles.separator} />;
}
